export default {
    PUBLISHED: 20,
    VERIFYING: 10
};
